import { Component, Vue } from 'vue-property-decorator';
import WithRender from './login.html';
import config from "@/settings/config.js";
import { IUserInfo, IUserProfile, UserClaim } from '@/Models/IUserInfo';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { userAuth } from '@/services/security';
import _axios from '@/services/axios';

@WithRender
@Component({
  components: {
    Loading,
  }
})
export default class Login extends Vue {
  username: string = "";
  password: string = "";
  userInfo: IUserInfo = {} as IUserInfo;
  userProfile: IUserProfile = {} as IUserProfile;
  isLoading = false;
  toastMessage: string = "";
  errorMsg = "";

  async runLoginSequence() {
    try {
      this.isLoading = true;
      await this.login();
      await this.getUserClaim();
      this.$router.push("balance");
    } catch (error) {
      this.$bvToast.toast(this.errorMsg, {
        title: 'Notification',
        variant: 'danger',
        autoHideDelay: 5000,
      }),
        console.error(error);
    } finally {
      this.isLoading = false;
    }
  }

  private async login() {
    let dto = {
      UserName: this.username,
      Password: this.password
    }
    try {
      const response = await _axios.post(config.identity.authority + "/Login", dto);
      this.userInfoSet(response.data);
      await this.storeUserInfo();
    } catch (error) {
      this.errorMsg = 'Invalid username or password';
      throw error;
    }
  }

  private async getUserClaim() {
    try {
      const response = await _axios.get<UserClaim>(`${config.identity.authority}/connect/userinfo`);
      const claim = response.data;
      this.userInfo.profile.Role = claim.Role;
      await this.storeUserInfo();
    } catch (error) {
      this.errorMsg = 'User not authorised';
      throw error;
    }
  }

  private userInfoSet(value: IUserInfo) {
    this.userInfo = value;
    this.userInfo.username = this.username;
    this.userProfile.name = this.username;
    this.userInfo.profile = this.userProfile;
    this.userInfo.isManualLogin = true;
  }

  private async storeUserInfo() {
    try {
      await this.$store.dispatch('login/setUser', this.userInfo);
      this.getUserClaim();
    } catch (err) {
      console.error(err);
    }
  }

  async LoginGoogle() {
    this.isLoading = true;
    userAuth.signIn("/balance");
  }
}